<template>
  <div :class="classes" :style="styles" ref="toast">
    <a class="toast__close" @click="close">
      <m4-icon icon="close"></m4-icon>
    </a>
    <div class="toast__icon">
      <m4-icon icon="exclamation" v-if="alert"></m4-icon>
      <m4-icon icon="info" v-else></m4-icon>
    </div>
    <div class="toast__info">
      <div v-if="title" class="toast__info__header">
        {{ title }}
      </div>
      <div class="toast__info__body"><slot></slot>{{ body }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Toast",
  data() {
    return {
      visible: this.initVisible,
      marginTop: 0,
      newDelay: this.delay,
      body: null,
      initClasses: null,
      timeout: null
    };
  },
  props: {
    title: String,
    variant: String,
    alert: Boolean,
    delay: {
      type: Number,
      default() {
        return 4;
      }
    },
    initVisible: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  emits: ["closeToast"],
  mounted() {
    this.initOpen(true);

    if (!this.initVisible) {
      this.initClasses = "toast--init-hidden";
      setTimeout(() => (this.initClasses = ""), 1000);
    }
  },
  computed: {
    classes() {
      let classes = ["toast"];
      if (this.initClasses) {
        classes.push(this.initClasses);
      }
      if (this.variant) {
        classes.push("toast--" + this.variant);
      } else if (this.alert) {
        classes.push("toast--danger");
      } else {
        classes.push("toast--success");
      }
      if (this.visible === false) {
        classes.push("toast--closed");
      }
      return classes;
    },
    styles() {
      return {
        marginTop: this.marginTop + "px"
      };
    }
  },
  methods: {
    initOpen(multiple) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => this.close(), this.newDelay * 1000);

      if (multiple) {
        if (window.toastMessagesTop) {
          this.marginTop = window.toastMessagesTop;
          window.toastMessagesTop = window.toastMessagesTop + this.$refs.toast.clientHeight;
        } else {
          window.toastMessagesTop = this.$refs.toast.clientHeight;
        }
        window.toastMessagesTop = window.toastMessagesTop + 15;
      }
    },
    open() {
      this.visible = true;
      this.initOpen(false);
    },
    close() {
      this.visible = false;
      this.$emit("closeToast");
    },
    setNewDelay(delay) {
      this.newDelay = delay;
    },
    setBody(body) {
      this.body = body;
    }
  }
};
</script>
